import { render, staticRenderFns } from "./ListCustomFieldsTable.vue?vue&type=template&id=371c5d26&"
import script from "./ListCustomFieldsTable.vue?vue&type=script&lang=ts&"
export * from "./ListCustomFieldsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTd,QInput,QIcon} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTd,QInput,QIcon}, component.options.components || {})
